import { FaExclamationCircle } from "react-icons/fa"

export default function UrgentSign() {

    return (
        <FaExclamationCircle style={{ color: "red" }} />
    )
}